import * as Yup from 'yup';

export const ResolvableMissionTypeToolkitsSchema = Yup.object().shape({
  enabledToolkitIds: Yup.array()
    .of(Yup.string().required('Toolkit requis'))
    .optional()
    .nullable()
    .default(undefined),
});
